/**
 * @generated SignedSource<<22575f780e3aa4dc24679c6731fdb616>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment, RefetchableFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type DiskCleanupMedia_data$data = {
  readonly diskCleanerScan?: {
    readonly media: {
      readonly " $fragmentSpreads": FragmentRefs<"DiskCleanupResult_cleanInfo">;
    } | null;
  };
  readonly " $fragmentType": "DiskCleanupMedia_data";
};
export type DiskCleanupMedia_data$key = {
  readonly " $data"?: DiskCleanupMedia_data$data;
  readonly " $fragmentSpreads": FragmentRefs<"DiskCleanupMedia_data">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "input"
    },
    {
      "kind": "RootArgument",
      "name": "scan"
    }
  ],
  "kind": "Fragment",
  "metadata": {
    "refetch": {
      "connection": null,
      "fragmentPathInResult": [],
      "operation": require('./DiskCleanupMediaRefetchQuery.graphql')
    }
  },
  "name": "DiskCleanupMedia_data",
  "selections": [
    {
      "condition": "scan",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "alias": null,
          "args": [
            {
              "kind": "Variable",
              "name": "input",
              "variableName": "input"
            }
          ],
          "concreteType": "DiskCleanerResult",
          "kind": "LinkedField",
          "name": "diskCleanerScan",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "CleanInfo",
              "kind": "LinkedField",
              "name": "media",
              "plural": false,
              "selections": [
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "DiskCleanupResult_cleanInfo"
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    }
  ],
  "type": "Query",
  "abstractKey": null
};

(node as any).hash = "976f6c54f1189134de6a06f7b1c43c34";

export default node;
